import React from 'react';
import { Tabs } from 'antd';
import { useQueryFilter } from 'common/hooks/useQueryFilter';
import { EStatisticsTab, EStatisticsTabText } from 'entities/Statistic/Statistic.models';
import { StatisticsStoresTab } from 'entities/Statistic/components/StatisticsStoresTab';
import { StatisticsSalesTab } from 'entities/Statistic/components/StatisticsSalesTab';

export const FranchiseeStatistics: React.FC = () => {
  const defaultFilter = {
    tab: EStatisticsTab.Stores,
  };

  const { filter, updateFilter } = useQueryFilter(defaultFilter);

  const onTabChange = (tab: string) => {
    updateFilter({ tab: tab as EStatisticsTab });
  };

  return (
    <Tabs activeKey={filter.tab} onChange={onTabChange}>
      <Tabs.TabPane tab={EStatisticsTabText.Stores} key={EStatisticsTab.Stores}>
        {filter.tab === EStatisticsTab.Stores && <StatisticsStoresTab />}
      </Tabs.TabPane>
      <Tabs.TabPane tab={EStatisticsTabText.Sales} key={EStatisticsTab.Sales}>
        {filter.tab === EStatisticsTab.Sales && <StatisticsSalesTab />}
      </Tabs.TabPane>
    </Tabs>
  );
};
